"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _Partner = require("../../contexts/Partner");
var _Link = _interopRequireDefault(require("../common/Link"));
var _Container = _interopRequireDefault(require("../Container"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _SocialButtons = _interopRequireDefault(require("../SocialButtons"));
var _FooterLogo = _interopRequireDefault(require("./FooterLogo"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Footer = function Footer(_ref) {
  var name = _ref.name,
    inn = _ref.inn,
    ogrn = _ref.ogrn,
    unsubscribeLink = _ref.link;
  var _useContext = (0, _react.useContext)(_Partner.PartnerContext),
    isWl = _useContext.isWl,
    partnerName = _useContext.name,
    partnerLink = _useContext.link;
  var styles = {
    container: {
      fontSize: '13px',
      textAlign: 'center',
      color: _userflow["default"].colors.frenchGray
    },
    strong: {
      color: _userflow["default"].colors.blackBase
    },
    link: {
      color: _userflow["default"].colors.blue
    },
    partner: {
      textTransform: 'uppercase'
    }
  };
  var currentYear = new Date().getFullYear();
  var organizationName = "\u041E\u041E\u041E \xAB".concat(name, "\xBB");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FooterLogo["default"], {
    style: styles.container
  }), /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container
  }, isWl && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  }), "\u0412\u0430\u0448 \u0437\u0430\u043A\u0430\u0437 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u0435\u0442 \u0441\u0435\u0440\u0432\u0438\u0441 \u043F\u043E \u043E\u043D\u043B\u0430\u0439\u043D \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0442\u0443\u0440\u043E\u0432 Level.Travel.", /*#__PURE__*/_react["default"].createElement("br", null), "\u0412\u044B \u043E\u0444\u043E\u0440\u043C\u0438\u043B\u0438 \u0437\u0430\u043A\u0430\u0437 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 ".concat(partnerName, ".")), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 18
  }), "\u041C\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0440\u0430\u0441\u0441\u044B\u043B\u0430\u0435\u043C \u0441\u043F\u0430\u043C.", /*#__PURE__*/_react["default"].createElement("br", null), "\u0415\u0441\u043B\u0438 \u044D\u0442\u043E \u043F\u0438\u0441\u044C\u043C\u043E \u043F\u043E\u043F\u0430\u043B\u043E \u043A \u0432\u0430\u043C \u043F\u043E \u043E\u0448\u0438\u0431\u043A\u0435, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0438\u0433\u043D\u043E\u0440\u0438\u0440\u0443\u0439\u0442\u0435 \u0435\u0433\u043E.", /*#__PURE__*/_react["default"].createElement("br", null), !isWl && "".concat(organizationName, " \u2014 \u0418\u041D\u041D ").concat(inn, " \u2014 \u041E\u0413\u0420\u041D ").concat(ogrn), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 18
  }), /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    style: _objectSpread(_objectSpread({}, styles.link), styles.partner),
    href: partnerLink
  }, partnerName), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 3
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.strong
  }, "\u0421\u0435\u0440\u0432\u0438\u0441 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0443\u0440\u043E\u0432 \u043E\u043D\u043B\u0430\u0439\u043D"), !isWl && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 6
  }), /*#__PURE__*/_react["default"].createElement(_SocialButtons["default"], null), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 14
  }), "\u0415\u0441\u043B\u0438 \u0432\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043D\u0430\u0448\u0443 \u043A\u043E\u0440\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0446\u0438\u044E, \u043D\u0430\u0436\u043C\u0438\u0442\u0435", ' ', /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    style: styles.link,
    href: unsubscribeLink
  }, "\u0441\u044E\u0434\u0430")), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 29
  })), !isWl && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: _objectSpread(_objectSpread({}, styles.container), styles.strong),
    bgColor: "#fff",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 12
  }), "".concat(organizationName, ", \u041C\u043E\u0441\u043A\u0432\u0430 2011\u2013").concat(currentYear, " \u0433."), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 15
  })), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 50
  })));
};
Footer.propTypes = {
  name: _propTypes["default"].string.isRequired,
  inn: _propTypes["default"].string.isRequired,
  ogrn: _propTypes["default"].string.isRequired,
  link: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Footer;